import { api } from '.';

export interface WorkRestProfile {
  id: string;
  locationId: string;
  customerId: number;
  primaryMetric: 'WBGT' | 'Temperature' | 'Heat Index';
  intensities: WorkRestIntensity[];
  modifiers: WorkRestModifier[];
  riskLevels: WorkRestRiskLevel[];
  matrices: WorkRestMatrix[];
  durationUnit: string;
  useRiskProfile: boolean;
  customStopText: string;
  customContinuousText: string;
}

export interface WorkRestModifier {
  id: number;
  name: string;
  adjustment: number;
  workRestProfileId: string;
}

export interface WorkRestIntensity {
  id: number;
  name: string;
  level: number;
  workRestProfileId: string;
}

export interface WorkRestRiskLevel {
  id: number;
  name: string;
  level: number;
  color: string;
  workRestProfileId: string;
}

export interface WorkRestMatrix {
  id: number;
  max: number;
  workPercent: number;
  workRestProfileId: string;
  workRestIntensityId: number;
  workRestRiskLevelId: number;
}

const workRestApi = api.injectEndpoints({
  endpoints: builder => ({
    workRestProfileForLocation: builder.query<WorkRestProfile | null, string>({
      query: locationId => ({ url: `WorkRest/ForLocation/${locationId}` }),
      transformResponse: (response: { data: WorkRestProfile | null }) => response.data,
      providesTags: ['WorkRestProfile'],
    }),
  }),
});

export const { useWorkRestProfileForLocationQuery, useLazyWorkRestProfileForLocationQuery } = workRestApi;
